import styled from "styled-components";
export const RatingNumbersWrapper = styled.fieldset `
  display: flex;
  justify-content: center;
  row-gap: 12px;
  column-gap: 8px;
  flex-wrap: wrap;
`;
//# sourceMappingURL=RatingNumbers.style.js.map